import { render, staticRenderFns } from "./DropZone.vue?vue&type=template&id=3d545c93"
import script from "./DropZone.vue?vue&type=script&lang=js"
export * from "./DropZone.vue?vue&type=script&lang=js"
import style0 from "./DropZone.vue?vue&type=style&index=0&id=3d545c93&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports